var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 80H11V12H63V58",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6609 74.1315C64.629 73.2142 63.0488 73.3071 62.1315 74.3391C61.2142 75.371 61.3071 76.9512 62.3391 77.8685L64 76L65.6609 74.1315ZM68.5 80L66.8391 81.8685C67.8629 82.7786 69.4284 82.6953 70.3499 81.6817L68.5 80ZM80.3499 70.6817C81.2786 69.66 81.2033 68.0789 80.1817 67.1501C79.16 66.2214 77.5789 66.2967 76.6501 67.3183L78.5 69L80.3499 70.6817ZM89 74H86.5C86.5 82.5604 79.5604 89.5 71 89.5V92V94.5C82.3218 94.5 91.5 85.3218 91.5 74H89ZM71 92V89.5C62.4396 89.5 55.5 82.5604 55.5 74H53H50.5C50.5 85.3218 59.6782 94.5 71 94.5V92ZM53 74H55.5C55.5 65.4396 62.4396 58.5 71 58.5V56V53.5C59.6782 53.5 50.5 62.6782 50.5 74H53ZM71 56V58.5C79.5604 58.5 86.5 65.4396 86.5 74H89H91.5C91.5 62.6782 82.3218 53.5 71 53.5V56ZM64 76L62.3391 77.8685L66.8391 81.8685L68.5 80L70.1609 78.1315L65.6609 74.1315L64 76ZM68.5 80L70.3499 81.6817L80.3499 70.6817L78.5 69L76.6501 67.3183L66.6501 78.3183L68.5 80Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 27.5H50.5",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 40H51",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52H51",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.74891154.svg";
export { ForwardRef as ReactComponent };